import React from "react";
import { Box, Link as MuiLink, Typography } from "@mui/material";

import { useAuth } from "../../context/authContext";
import FriendJournalEntry from "./FriendJournalEntry";

/**
 * Content of LibraryModal's @username tab: someone else's journal entry,
 * opened directly — from a shared link, an Explore activity card, or a tile on
 * their track page. It gets a tab of its own rather than sitting under
 * Following, since its author may be someone the viewer doesn't follow (or the
 * viewer may not be signed in at all).
 */
export default function FocusedEntry({ linkedEntry }) {
  const { user, login } = useAuth();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
      <FriendJournalEntry
        entry={linkedEntry.entry}
        person={linkedEntry.author}
      />

      {/* Signed-out visitors mostly land here from a shared link — the moment
          to nudge them towards logging their own. MuiLink (primary) matches
          the app's other sign-in prompts. */}
      {!user && (
        <Typography variant="body2" color="text.disabled">
          <MuiLink component="span" onClick={login} sx={{ cursor: "pointer" }}>
            Sign in
          </MuiLink>{" "}
          to log your own take
        </Typography>
      )}
    </Box>
  );
}
